const overviewCardsData = [
    {
      icon: 'DownloadGradient',
      title: 'Enrich audience',
      text: 'Enrich your target audience by creating a form on your HubSpot website.',
      button: {
        title: 'Start now',
        style: 'tertiary',
        link: '/enrich-audience',
        icon: 'ArrowRight',
        animation: 'move-right'
      }
    },
    {
      icon: 'LightBulbGradient',
      title: 'Enrich company',
      text: 'Enrich company data by entering or changing it\'s dossier number.',
      button: {
        title: 'Start now',
        style: 'tertiary',
        link: '/enrich-company',
        icon: 'ArrowRight',
        animation: 'move-right'
      }
    },
    {
      icon: 'SearchGradient',
      title: 'Search company',
      text: 'Manually search company data and save it\'s results in HubSpot.',
      button: {
        title: 'Start now',
        style: 'tertiary',
        link: '/search-company',
        icon: 'ArrowRight',
        animation: 'move-right'
      }
    }
  ];

export default overviewCardsData;



